import {
  LineMessageBlockContainer,
  LineMessageBlockImage,
  LineMessageBlockPreview,
  LineMessageBlockUrlPreview,
} from './LineMessageBlocksContainer';

export const LineMessageBlock = {
  Container: LineMessageBlockContainer,
  Preview: LineMessageBlockPreview,
  Image: LineMessageBlockImage,
  UrlPreview: LineMessageBlockUrlPreview,
};
